// This file serves for all custom variables/functions that are used in the app

// Custom rendering for persons per night on RatesPicker
export const customRenderingPPNOrganizations = ["Wine Camp Hažić", "Camp Zagreb"];

export const hideTermsAndPrivacyPolicy = ["Campuccino"];
